import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import {Container as ContainerBase } from "components/misc/Layouts.js"
import logo from "../../images/logo.svg";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as YoutubeIcon } from "../../images/youtube-icon.svg";


const Container = tw(ContainerBase)`bg-gray-900 text-gray-100 -mx-8 -mb-8`
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;

const Row = tw.div`flex items-center justify-center flex-col px-8`

const LogoContainer = tw.div`flex items-center justify-center md:justify-start`;
const LogoImg = tw.img`w-8`;
const LogoText = tw.h5`ml-2 text-2xl font-black tracking-wider`;

const LinksContainer = tw.div`mt-8 font-medium flex flex-wrap justify-center items-center flex-col sm:flex-row`
const Link = tw.a`border-b-2 border-transparent hocus:text-gray-300 hocus:border-gray-300 pb-1 transition duration-300 mt-2 mx-4`;
const Column = tw.div`md:w-full`;
const WideColumn = tw(Column)`text-center md:text-left w-full md:w-2/5 mb-10 md:mb-0`;

const ColumnHeading = tw.h5`font-bold`;

const LinkList = tw.ul`mt-4 text-sm font-medium`;
const LinkListItem = tw.li`mt-3`;
//const Link = tw.a`border-b-2 border-transparent hocus:text-primary-500 hocus:border-primary-500 pb-1 transition duration-300`;

const SocialLinksContainer = tw.div`mt-10`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block text-gray-100 hover:text-gray-500 transition duration-300 mx-4`}
  svg {
    ${tw`w-5 h-5`}
  }
`;

const CopyrightText = tw.p`text-center mt-10 font-medium tracking-wide text-sm text-gray-600`
export default () => {
  return (
    <Container>
      
      <Content>
        <Row>
        <LogoContainer>
        <LogoImg src={"/assets/img/logo.png"} />
        <LogoText>Sonali Tours & Travels</LogoText>
        </LogoContainer>
        <Row>
          <LinkList>
            <LinkListItem>
              <Link href="/PrivacyPolicy">Privacy Policy</Link>
            </LinkListItem>
            <LinkListItem>
              <Link href="/TermsOfService">Terms & Conditions</Link>
            </LinkListItem>
          </LinkList>
        </Row>
        <br/>
        <div className="container mt-5">
          <div className="row text-white justify-content-center mt-3 pb-3">
            <div className="col-12 col-sm-6 col-lg-3 mx-auto">
            <h5 className="text-capitalize fw-bold">Sonali Tours & Travles</h5>
            <hr className="bg-white d-inline-block mb-4" style={{width: "60", height: "2"}}/><br/>
            <p className="lh-lg">
              House No.04, Niwara CHS plot No B4 Sector 5 Khanda Colony Panvel, Navi Mumbai.410206
            </p><br/>
            <p>Email:sonalitourstravelsmumbai@gmail.com</p><br/>
            <p>Call:9324755521</p><br/>
            <p className="lh-lg">
              We are Sonali Tours & Travels are registerd company having experience of 10+ years. and served more then 1000+ happy Customers.
            </p>
            </div>
            <div className="col-12 col-sm-6 col-lg-3 mb-4 mx-auto">
            <h5 className="text-capitalize fw-bold">Regular Trip</h5>
            <hr className="bg-white d-inline-block mb-4" style={{width: "60", height: "2"}}/>
            <ul className="list-inline campany-list">
            <li><a href="/Trips/Mumbai-To-Kolhapur/1">Mumbai To Kolhapur</a></li>
            
              <li><a href="/Trips/Mumbai-To-Sambhaji-Nagar/4">Mumbai to Sambhaji Nagar</a></li>
              <li><a href="/Trips/Mumbai-To-nashik/5">Mumbai to Nashik</a></li>
              <li><a href="/Trips/Mumbai-To-Mahableswar/6">Mumbai To Mahableswar</a></li>
              <li><a href="/Trips/Mumbai-To-Shirdi/12">Mumbai To Shirdi</a></li>
              <li><a href="/Trips/Mumbai-To-Panchgani/11">Mumbai To Panchgani</a></li>
              <li><a href="/Trips/Mumbai-To-Goa/7">Mumbai To Goa</a></li>
              <li><a href="/Trips/Mumbai-To-Ashtavinayak/14">Mumbai To Ashtavinayak</a></li>
              <li><a href="#">Mumbai To Grishneshwar</a></li>             
              <li><a href="/Trips/Mumbai-To-Bhimshankar/15">Mumbai To Bhimashanker</a></li>           
              <li><a href="#">Mumbai To Lonvala Khandala</a></li>   
              
            </ul>
            
            </div>
            <div className="col-12 col-sm-6 col-lg-3 mb-4 mx-auto">
            <h5 className="text-capitalize fw-bold">Regular Trip</h5>
            <hr className="bg-white d-inline-block mb-4" style={{width: "60",height: "2"}}/>
            <ul className="list-inline campany-list">
              <li><a href="/Trips/Mumbai-To-pune/3">Mumbai To Pune</a></li>
              <li><a href="/Trips/Mumbai-To-Alibag/12">Mumbai To Alibag</a></li>
              <li><a href="/Trips/Mumbai-To-Malvan/8">Mumbai To Kokan</a></li>
              <li><a href="/Trips/Mumbai-To-Malvan/8">Mumbai To Malvan</a></li>
              <li><a href="/Trips/Mumbai-To-Malvan/8">Mumbai To Sindhudurg</a></li>
              <li><a href="/Trips/Mumbai-To-Ganpatipule/9">Mumbai To Ganpatipule</a></li>
              
              <li><a href="/Trips/Mumbai-To-pune/3">Mumbai To Pune Airport</a></li>
              <li><a href="/Trips/Mumbai-To-Beed/13">Mumbai To Beed</a></li>
              <li><a href="/Trips/Mumbai-To-Lonavala/">Mumbai To Lonavala Khandal</a></li>
              <li><a href="#">Mumbai To Nanded</a></li>
              <li><a href="#">Mumbai To Parbhani</a></li>
              <li><a href="#">Mumbai To Sangli</a></li>
              <li><a href="#">Mumbai To Audha Nagnath</a></li>
            </ul>
            </div>
            
          </div>
        </div>

          
            
            
          
          
          
          <CopyrightText>
            &copy; <a href="#">Sonali Tours & Travels</a> | Created by <a href="http://www.ellipsesofttech.com" target="_blank">Ellipse Software Technology</a>
          </CopyrightText>
        </Row>
      </Content>
      
    </Container>
  );
};
